import { render, staticRenderFns } from "./alarmType.vue?vue&type=template&id=88baedc6&scoped=true"
import script from "./alarmType.vue?vue&type=script&lang=js"
export * from "./alarmType.vue?vue&type=script&lang=js"
import style0 from "./alarmType.vue?vue&type=style&index=0&id=88baedc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88baedc6",
  null
  
)

export default component.exports